"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedJobListResponseSchema = exports.SaveJobListResultSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const schemas_1 = require("../../../../schemas");
const SavedJobListItemSchema = schemas_1.JobPostingSchema.pick({
    coverImage: true,
    estimatedSalaryMax: true,
    estimatedSalaryMin: true,
    expiredAt: true,
    id: true,
    locationDetail: true,
    postedAt: true,
    title: true,
}).extend({
    company: schemas_1.CompanyProfileSchema.pick({ companyName: true }),
    hasApplied: zod_1.default.boolean(),
    hasSaved: zod_1.default.boolean(),
    status: schemas_1.SavedJobStatusEnum,
});
exports.SaveJobListResultSchema = zod_1.default.object({ savedJobs: SavedJobListItemSchema.array() }).merge(schemas_1.PaginationResponseSchema);
exports.SavedJobListResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.SaveJobListResultSchema);
